import { Backdrop } from '@mui/material';
import * as React from 'react';
import { Loader } from './Loader';

interface Props {
  open: boolean;
  children?: React.ReactNode;
  className?: string;
}

export const BackdropLoader: React.FC<Props> = (props) => {
  const { open, className, children } = props;
  return (
    <Backdrop open={open} style={{ zIndex: 1 }}>
      <Loader className={className}>{children}</Loader>
    </Backdrop>
  );
};
BackdropLoader.displayName = 'PerDiemArchive.BackdropLoader';
